import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Variation = 'conservative' | 'balanced' | 'bold';
export type Density = 'compact' | 'regular' | 'comfy';
export type Theme = 'light' | 'dark';

interface ThemeState {
  variation: Variation;
  density: Density;
  theme: Theme;
  sidebarCollapsed: boolean;
  setVariation: (v: Variation) => void;
  setDensity: (d: Density) => void;
  setTheme: (t: Theme) => void;
  toggleSidebar: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      variation: 'balanced',
      density: 'regular',
      theme: 'light',
      sidebarCollapsed: false,
      setVariation: (variation) => set({ variation }),
      setDensity: (density) => set({ density }),
      setTheme: (theme) => set({ theme }),
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
    }),
    { name: 'merkaziya-theme' }
  )
);

export function applyThemeToHtml(state: Pick<ThemeState, 'variation' | 'density' | 'theme'>): void {
  const html = document.documentElement;

  html.classList.remove('variation-conservative', 'variation-bold');
  if (state.variation === 'conservative') html.classList.add('variation-conservative');
  if (state.variation === 'bold') html.classList.add('variation-bold');

  html.classList.remove('density-compact', 'density-comfy');
  if (state.density === 'compact') html.classList.add('density-compact');
  if (state.density === 'comfy') html.classList.add('density-comfy');

  html.classList.toggle('theme-dark', state.theme === 'dark');
}
